import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  topUpInputField: {
    marginBottom: theme.spacing(15),
  },
  cardElementLabel: {
    display: 'flex',
    fontSize: 18,
    fontWeight: 300,
    lineHeight: '30px',
    color: '#000',
    paddingBottom: '5px',
  },
  cardElement: {
    marginBottom: theme.spacing(15),
    border: '1px solid #ABAFB3',
    borderRadius: 10,
    padding: '16.5px 15px',
    background: '#fff',
  },
  cardError: {
    marginTop: theme.spacing(-10),
    marginBottom: theme.spacing(10),
  },
  cardDetailsTitle: {
    fontSize: theme.spacing(12),
    lineHeight: '36px',
    fontWeight: 600,
    letterSpacing: 0,
  },
  topFormButton: {
    padding: theme.spacing(7.5, 29.5),
    '&.Mui-disabled': {
      backgroundColor: '#ABAFB3',
      color: '#fff',
    },
  },
  topFormButtonLabel: {
    textTransform: 'capitalize',
    fontSize: theme.spacing(9),
    lineHeight: '27px',
  },
}));
